import React, { useRef } from 'react';
import { NavLink } from 'react-router-dom';
import { useScrollRow } from './useScrollRow';
import './nav.css';

/**
 * Level 2 of the new navigation (the hub tab bar is level 1): ONE compact secondary row, the same everywhere —
 * a single horizontally scrollable line, smaller than the hub tabs, no card or box, never wrapping, no visible
 * scrollbar, an edge fade when more tabs exist, and the active tab scrolled into view on load.
 *
 * items: [{ id, label, active, to?, onClick?, badge? }]. A link when `to` is set, otherwise a button.
 */
export default function SubTabs({ items, ariaLabel }) {
  const rowRef = useRef(null);
  const activeId = items.find((i) => i.active)?.id;
  useScrollRow(rowRef, activeId);
  if (!items || items.length < 2) return null; // one tab = nothing to switch between

  return (
    <div className="pp-scrollfade pp-subtabs-wrap" data-testid="pp-subtabs">
      <div ref={rowRef} className="pp-subtabs" role="tablist" aria-label={ariaLabel}>
        {items.map((i) => {
          const cls = `pp-subtab${i.active ? ' pp-subtab-active' : ''}`;
          const inner = <>{i.label}{i.badge ? <span className="pp-subtab-badge">{i.badge}</span> : null}</>;
          return i.to ? (
            <NavLink key={i.id} to={i.to} end className={cls} aria-current={i.active ? 'page' : undefined} data-subtab={i.id}>{inner}</NavLink>
          ) : (
            <button key={i.id} type="button" role="tab" aria-selected={!!i.active} className={cls} onClick={i.onClick} data-subtab={i.id}>{inner}</button>
          );
        })}
      </div>
    </div>
  );
}
